module.exports = __webpack_public_path__ + "static/offer-3-25dcedd198d3380d8b9d2de3f5fbaeda.png";